const appConfig = {
    apiPrefix: '/api/v1',
    authenticatedEntryPath: '/users',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    enableMock: false
}

export default appConfig